import React, {
  FunctionComponent,
  ReactElement,
  ReactNode,
  useEffect,
} from "react";
import { useLocation } from "react-router-dom";
import { Box, Tab, Tabs as TabsMui, Button } from "@mui/material";
import { CSVLink } from "react-csv";
import { EsgExcelExport } from "assets";
// TODO: TEMPORAL - REMOVE useGetIntensityEmbedUrl import when Intensity external link functionality is removed
import { useGetIntensityEmbedUrl } from "hooks";

export const DashboardTabs: FunctionComponent<{
  tabs: {
    icon?: ReactElement;
    label: ReactNode;
    content: ReactNode;
    // TODO: TEMPORAL - REMOVE isExternalLink from interface when Intensity external link functionality is removed
    isExternalLink?: boolean;
  }[];
  selectedBtnOption?: string;
  intensity?: boolean;
  refrences?: boolean;
  onTabChange?: Function;
  textColor?: string;
  dashboard?: boolean;
  exportData?: any;
  showExportButton?: boolean;
  CsvMatchedData?: any;
}> = ({ tabs, selectedBtnOption, intensity, onTabChange, refrences, dashboard = false, textColor = "#054254", exportData, showExportButton, CsvMatchedData }) => {
  const [value, setValue] = React.useState(0);
  // TODO: TEMPORAL - REMOVE useGetIntensityEmbedUrl when Intensity external link functionality is removed
  const { mutateAsync: getIntensityEmbedUrl } = useGetIntensityEmbedUrl();

  const location = useLocation();

  // URLSearchParams is used to parse the query string
  const queryParams = new URLSearchParams(location.search);
  const siteId = queryParams.get('s');

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    const selectedTab = tabs[newValue];

    // TODO: TEMPORAL - REMOVE this entire if block when Intensity external link functionality is removed
    // If it's an external link, prevent tab change - the onMouseDown handler will open the link
    if (selectedTab?.isExternalLink) {
      event.preventDefault();
      return; // Don't change the tab value, stay on current tab
    }

    setValue(newValue);
    if (onTabChange) {
      onTabChange(newValue);
    }
  };

  useEffect(() => {
    if (selectedBtnOption === "Active") {
      setValue(0);
    } else if (selectedBtnOption === "Inactive") {
      setValue(1);
    } else if (selectedBtnOption === "Renewable Energy Purchases") {
      setValue(2);
    } else if (selectedBtnOption === "Intensity") {
      setValue(3);
    } else if (selectedBtnOption === "Emissions Allocation") {
      setValue(4);
    } else {
      setValue(0);
      if (onTabChange) {
        onTabChange(0);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBtnOption]);

  useEffect(() => {
    if (siteId) {
      setValue(3)
    }
  }, [siteId])


  return (
    /* eslint-disable react/no-array-index-key */
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
      }}
    >
      <Box sx={{ borderBottom: 1, borderColor: "divider", display: "flex", justifyContent: "space-between" }}>
        <TabsMui
          value={value}
          onChange={handleChange}
          textColor={intensity ? "inherit" : undefined}
          TabIndicatorProps={{
            style: {
              ...(intensity && {
                backgroundColor: `${textColor}`,
              })
            }
          }}
          sx={{
            ".Mui-selected": {
              ...(intensity && {
                color: `${textColor} !important`, fontWeight: "700"
              })
            },
          }}
        >
          {tabs.map((tab, index) => (
            <Tab
              key={`tab-${index}`}
              icon={tab.icon}
              label={tab.label}
              iconPosition="start"
              id={`tab-${index}`}
              aria-controls={`tabpanel-${index}`}
              onMouseDown={async (e) => {
                // TODO: TEMPORAL - REMOVE this onMouseDown handler when Intensity external link functionality is removed
                // Use onMouseDown to intercept before TabsMui processes the click
                if (tab.isExternalLink) {
                  e.preventDefault();
                  e.stopPropagation();
                  // Fetch the URL only when clicked, as it changes each time
                  try {
                    const response = await getIntensityEmbedUrl();
                    if (response?.embedUrl) {
                      window.open(response.embedUrl, '_blank', 'noopener,noreferrer');
                    }
                  } catch (error) {
                    console.error('Failed to get Intensity embed URL:', error);
                  }
                }
              }}
              sx={{
                minHeight: "48px",
                margin: "0 0 0 10px",
                textTransform: "none",
                fontWeight: "600",
                fontSize: "14px",
                lineHeight: "18px",
                color: "#000 !important",
                ...(intensity && {
                  height: "22px",
                  gap: "37px",
                  padding: "0",
                  marginRight: "36px",
                })
              }}
            />
          ))}
        </TabsMui>
        {showExportButton && <Box mb={2}>
          <CSVLink
            style={{ textDecoration: "none" }}
            data={CsvMatchedData() ?? []}
            filename={`${exportData.replace(" ", "-")}.csv`}
          >
            <Button sx={{ width: "200px", borderRadius: "8px" }} variant="contained" startIcon={<EsgExcelExport />}>
              Export CSV
            </Button>
          </CSVLink>
        </Box>}
      </Box>
      {tabs.map((tab, index) => {
        // TODO: TEMPORAL - REMOVE this if block when Intensity external link functionality is removed
        // Don't render content for external links
        if (tab.isExternalLink) {
          return null;
        }
        return (
          <Box
            sx={refrences
              ? { mt: 3, flexGrow: 1, overflow: "auto" }
              : dashboard ? { display: "flex", flexWrap: "wrap", width: "100%" }
                : { mt: 3, flexGrow: 1, overflow: "auto" }
            }
            key={`tabpanel-${index}`}
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
          >
            {value === index && tab.content}
          </Box>
        );
      })}
    </Box>
    /* eslint-enable react/no-array-index-key */
  );
};
